$(function(){
	setupFacebookShare();
})

function setupFacebookShare() {
  $('.knihaobliceju-sdilet').click(function(e) {
    e.preventDefault();

    var height = 600,
    width = 600,
    left  = ($(window).width()/2)-(width/2),
    top   = ($(window).height()/2)-(height/2),
    popup = window.open ($(this).attr('href'), "popup", "width="+width+", height="+height+", top="+top+", left="+left);

  });
}
